import React from 'react';
import { HashRouter, Routes, Route } from 'react-router-dom';
import { creators, recentVideos, savedVideosData, analyticsData } from './constants';
import { SettingsProvider } from './contexts/SettingsContext';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import CreatorProfile from './pages/CreatorProfile';
import Library from './pages/Library';
import Analytics from './pages/Analytics';
import Settings from './pages/Settings';
import Placeholders from './pages/Placeholders';

const App: React.FC = () => {
    return (
        <SettingsProvider>
            <HashRouter>
                <Routes>
                    <Route element={<Layout />}>
                        <Route path="/" element={<Dashboard creators={creators} recentVideos={recentVideos} />} />
                        <Route path="/creator/:creatorId" element={<CreatorProfile creators={creators} />} />
                        <Route path="/library" element={<Library savedVideos={savedVideosData} />} />
                        <Route path="/analytics/:creatorId" element={<Analytics creators={creators} analyticsData={analyticsData} />} />
                        <Route path="/settings" element={<Settings />} />
                        <Route path="/profile" element={<Settings />} />
                        <Route path="/search" element={<Placeholders pageKey="nav.search" />} />
                        <Route path="/add" element={<Placeholders pageKey="nav.add" />} />
                        <Route path="/creators" element={<Placeholders pageKey="nav.creators" />} />
                        <Route path="*" element={<Placeholders pageKey="placeholders.notFound" />} />
                    </Route>
                </Routes>
            </HashRouter>
        </SettingsProvider>
    );
};

export default App;